"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropertyType_1 = require("../classes/PropertyType");
const mapper = new PropertyType_1.default();
const propertyTypeMapper = mapper.toMapperInterface();
exports.default = propertyTypeMapper;
//# sourceMappingURL=property-type-mapper.js.map